import {
  LockAuditLogTitle,
  LockReasonEnum,
  LockReasonTitle,
  LockAuditLogActionEnum,
} from '../types';

export const actions = [
  {
    name: LockAuditLogTitle.AUTH_CREDENTIAL_PHONE_SEND_SMS,
    value: LockAuditLogActionEnum.AUTH_CREDENTIAL_PHONE_SEND_SMS,
  },
  {
    name: LockAuditLogTitle.USER_AUTH_EMAIL,
    value: LockAuditLogActionEnum.USER_AUTH_EMAIL,
  },
  {
    name: LockAuditLogTitle.USER_AUTH_PHONE,
    value: LockAuditLogActionEnum.USER_AUTH_PHONE,
  },
  {
    name: LockAuditLogTitle.USER_AUTH_PIN,
    value: LockAuditLogActionEnum.USER_AUTH_PIN,
  },
  {
    name: LockAuditLogTitle.USER_CONVERT_TOKEN,
    value: LockAuditLogActionEnum.USER_CONVERT_TOKEN,
  },
  {
    name: LockAuditLogTitle.USER_GENERATE_CHECKSUM,
    value: LockAuditLogActionEnum.USER_GENERATE_CHECKSUM,
  },
  {
    name: LockAuditLogTitle.USER_REFRESH_TOKEN,
    value: LockAuditLogActionEnum.USER_REFRESH_TOKEN,
  },
  {
    name: LockAuditLogTitle.USER_SEND_EMAIL_CODE_SIGNATURE,
    value: LockAuditLogActionEnum.USER_SEND_EMAIL_CODE_SIGNATURE,
  },
  {
    name: LockAuditLogTitle.USER_SEND_PUSH_CODE_SIGNATURE,
    value: LockAuditLogActionEnum.USER_SEND_PUSH_CODE_SIGNATURE,
  },
  {
    name: LockAuditLogTitle.USER_SEND_RESET_PASSWORD,
    value: LockAuditLogActionEnum.USER_SEND_RESET_PASSWORD,
  },
  {
    name: LockAuditLogTitle.USER_SEND_SMS_CODE_SIGNATURE,
    value: LockAuditLogActionEnum.USER_SEND_SMS_CODE_SIGNATURE,
  },
  {
    name: LockAuditLogTitle.USER_SEND_TOTP_CODE_SIGNATURE,
    value: LockAuditLogActionEnum.USER_SEND_TOTP_CODE_SIGNATURE,
  },
  {
    name: LockAuditLogTitle.USER_SET_PIN,
    value: LockAuditLogActionEnum.USER_SET_PIN,
  },
  {
    name: LockAuditLogTitle.USER_SIGNATURE_VERIFY_CODE,
    value: LockAuditLogActionEnum.USER_SIGNATURE_VERIFY_CODE,
  },
  {
    name: LockAuditLogTitle.USER_VERIFY_CODE,
    value: LockAuditLogActionEnum.USER_VERIFY_CODE,
  },
  {
    name: LockAuditLogTitle.USER_VERIFY_PASSWORD,
    value: LockAuditLogActionEnum.USER_VERIFY_PASSWORD,
  },
  {
    name: LockAuditLogTitle.USER_VERIFY_RESET_CODE,
    value: LockAuditLogActionEnum.USER_VERIFY_RESET_CODE,
  },
  {
    name: LockAuditLogTitle.USER_VERIFY_SIGNATURE,
    value: LockAuditLogActionEnum.USER_VERIFY_SIGNATURE,
  },
  {
    name: LockAuditLogTitle.USER_VERIFY_TOTP,
    value: LockAuditLogActionEnum.USER_VERIFY_TOTP,
  },
  {
    name: LockAuditLogTitle.USER_ACTIVATE_TOTP,
    value: LockAuditLogActionEnum.USER_ACTIVATE_TOTP,
  },
  {
    name: LockAuditLogTitle.USER_SEND_VALIDATE_CODE_TOTP,
    value: LockAuditLogActionEnum.USER_SEND_VALIDATE_CODE_TOTP,
  },
  {
    name: LockAuditLogTitle.USER_GENERATE_TOTP,
    value: LockAuditLogActionEnum.USER_GENERATE_TOTP,
  },
  {
    name: LockAuditLogTitle.USER_DELETE_TOTP,
    value: LockAuditLogActionEnum.USER_DELETE_TOTP,
  },
  {
    name: LockAuditLogTitle.USER_FORBIDDEN,
    value: LockAuditLogActionEnum.USER_FORBIDDEN,
  },
];

export const reasons = [
  {
    name: LockReasonTitle.USER_TOO_MANY_WRONG_PASSWORDS,
    value: LockReasonEnum.USER_TOO_MANY_WRONG_PASSWORDS,
  },
  {
    name: LockReasonTitle.USER_TOO_MANY_WRONG_2FA_CODES,
    value: LockReasonEnum.USER_TOO_MANY_WRONG_2FA_CODES,
  },
  {
    name: LockReasonTitle.USER_TOO_MANY_WRONG_PINS,
    value: LockReasonEnum.USER_TOO_MANY_WRONG_PINS,
  },
  {
    name: LockReasonTitle.USER_TOO_MANY_VERIFY_SMS,
    value: LockReasonEnum.USER_TOO_MANY_VERIFY_SMS,
  },
  {
    name: LockReasonTitle.USER_TOO_MANY_VERIFY_EMAILS,
    value: LockReasonEnum.USER_TOO_MANY_VERIFY_EMAILS,
  },
  {
    name: LockReasonTitle.USER_TOO_MANY_VERIFY_PHONE_ATTEMPTS,
    value: LockReasonEnum.USER_TOO_MANY_VERIFY_PHONE_ATTEMPTS,
  },
  {
    name: LockReasonTitle.GLOBAL_SYSTEM_DOWNTIME,
    value: LockReasonEnum.GLOBAL_SYSTEM_DOWNTIME,
  },
  {
    name: LockReasonTitle.TWILIO_THROTTLE,
    value: LockReasonEnum.TWILIO_THROTTLE,
  },
  {
    name: LockReasonTitle.MANUAL,
    value: LockReasonEnum.MANUAL,
  },
];
